import { render, staticRenderFns } from "./Usergroup.vue?vue&type=template&id=169841fd"
import script from "./Usergroup.vue?vue&type=script&lang=js"
export * from "./Usergroup.vue?vue&type=script&lang=js"
import style0 from "./Usergroup.vue?vue&type=style&index=0&id=169841fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports